import http from './http';

export const TwoFactorApi = {
    status() {
        return http.get('/auth/two-factor/status');
    },

    enable() {
        return http.post('/auth/two-factor/enable');
    },

    confirm(code) {
        return http.post('/auth/two-factor/confirm', { code });
    },

    disable(currentPassword) {
        return http.post('/auth/two-factor/disable', {
            current_password: currentPassword,
        });
    },

    regenerateRecoveryCodes() {
        return http.post('/auth/two-factor/recovery-codes/regenerate');
    },

    exchangeToken() {
        return http.post('/auth/two-factor/exchange-token');
    },

    loginTwoFactor(pendingLoginToken, code) {
        return http.post('/auth/login/two-factor', {
            pending_login_token: pendingLoginToken,
            code,
        });
    },
};

export function downloadRecoveryCodes(codes) {
    const content = codes.join('\n');
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `codigos-recuperacao-2fa-${new Date().toISOString().slice(0, 10)}.txt`;
    link.click();
    URL.revokeObjectURL(url);
}

export function applyAuthResponse(store, response) {
    const data = response.data;
    store.commit('auth/setUser', data.user);
    store.commit('auth/setToken', data.token);
    store.commit('auth/setMustSetupTwoFactor', Boolean(data.must_setup_two_factor));
    return data;
}
